import React, { Component } from "react";
import "../styles/sermonPopup.css";

export default class SermonVideo extends Component {
  state = {
    showVideoAttachment: false,
  };

  videoAttachmentClicked = () => {
    this.setState({ showVideoAttachment: !this.state.showVideoAttachment });
  };

  render() {
    var dateLinkObj = {
      20200322: "Sn42W8dxdt8",
      20200329: "wWPh_w7nW-8",
      20200405: "nwGAoYHUZWM",
      20200412: "3VnG1iy2qCU",
      20200419: "ZyMbzqgKI4o",
      20200426: "ryvKaZu6fiU",
      20200503: "DIpoIQAMrCU",
      20200510: "-rjg45HfwrE",
      20200517: "E35iTTv8Uhs",
      20200524: "A46PqvcXn-0",
      20200531: "MaiVLQfTZw8",
      20200607: "1BXlsgUd6T0",
      20200614: "zWvDEKGBnQc",
      20200621: "qWD2dO6jEzE",
      20200628: "75EOmNKFCbE",
      20200705: "6KV5A3RDi2k",
      20200712: "i9g_u0fKfRk",
      20200719: "lttnwiQmylg",
      20200726: "X3vHi0SdbFo",
      20200802: "XyHzXtw4u2c",
      20200809: "EUO6tE8WgbI",
      20200816: "9CjXenaxSKo",
      20200823: "8wCxheGLio4",
      20200830: "0we_fhbF6xs",
      20200906: "GtRRvamDbbA",
      20200913: "2sj3u8Lc0_o",
      20200920: "mB5MD0AQ9x0",
      20200927: "BDKP5oT2Q6w",
      20201004: "AFd-Z5i7L4U",
      20201011: "vaCR5Y5qjTQ",
      20201018: "dlVC3ZlgrpM",
      20201025: "IqUpm6Dqbis",
      20201101: "XVKXnht_vm4",
      20201108: "W6f-6JJ7fhY",
      20201115: "IkUcSEFyt1g",
      20201122: "ernTPfzQmi8",
      20201129: "Au_JEvMtfc8",
      20201206: "wnqz6_N4TYE",
      20201213: "RsuL-8Lqkf0",
      20201220: "LKzNc-WzwHA",
      20201227: "Vm4V8dk1T2U",
      20201231: "DzljobsEjOQ",
      20210103: "YWizIOMOdFo",
      20210110: "xchTSKbhJi4",
      20210117: "9Hb5OJcGoPI",
      20210124: "kTnTSFf2HNM",
      20210131: "HNrtYBMu6yk",
      20210207: "mCy6AcnFO-c",
      20210214: "F6UZdnVps0Q",
      20210221: "coXvlsWUApE",
      20210228: "FSOnVyUwMJU",
      20210307: "pohoA51Vmu4",
      20210314: "GmgMzKs6308",
      20210321: "OI7S03Hkv3c",
      20210328: "7kPxDcAU0Pk",
      20210404: "ulEkfFzUchI",
      20210411: "jftqI4erfV8",
      20210418: "SdwjOPBrgfc",
      20210425: "tIjseM_12lA",
      20210502: "r5vgGddiFlw",
      20210509: "MNbbQdafI5g",
      20210516: "rHo6cuqWr4M",
      20210523: "kID1uReU_rk",
      20210530: "ES5KgbpsdM4",
      20210606: "2khQnVK5oxY",
      20210613: "Bw03Xk3BgXc",
      20210620: "PW1zDH1JxrA",
      20210627: "UGT8xUtB-KU",
      20210704: "LKgegxTkQys",
      20210711: "wWJYSCGey88",
      20210718: "QIwi7Fql96I",
      20210725: "E2TYfNMy7Vg",
      20210801: "PnXzpojpn14",
      20210808: "hUmie0PT-6U",
      20210815: "liApDGDxC7c",
      20210822: "K_VKUbqGJKc",
      20210829: "s1gIOnvMA94",
      20210905: "8JuloajjB7Y",
      20210919: "CJE0GPKpnEs",
      20210926: "SgtTmvRqLDA",
      20211003: "10wgKC0BAj8",
      20211010: "Vi-fCq6laLI",
      20211017: "DJAyCLpOUY0",
      20211024: "Jw0FoNkbJDQ",
      20211031: "Vm7HtY6SRSg",
      20211107: "e4CcSKqYjl0",
      20211114: "3f2vik6-QXs",
      20211121: "FiYwZwUm53Y",
      20211128: "fhWhvb8TBqA",
      20211205: "FwyygOGzlp4",
      20211212: "jeWsJpzedxA",
      20211219: "NJBpdcdUkVE",
      20211226: "Zidym31ZkHc",
      20211231: "uTDHa3w6plE",
      20220102: "QnMK08bKwQI",
      20220109: "ea682FY4gIw",
      20220116: "WgFW_5e5MBI",
      20220123: "Uur8sjmHPoI",
      20220130: "3h-7fEg0gGg",
      20220206: "ZyGkm8BB7cU",
      20220213: "lwzAchwb5n8",
      20220220: "qhkA6YEIOfs",
      20220227: "VSMWfkqRJFI",
      20220306: "Gs0H2doakrM",
      20220313: "l2ikv9JF0zE",
      20220320: "BGhtvlLDhfI",
      20220327: "Qc33pmGur6g",
      20220403: "VbFELwibylo",
      20220410: "nZTa-7-X5fA",
      20220417: "yQfUX0flvV4",
      20220424: "-tV7EmC9VnM",
      20220501: "QnM9X4ZhI4Q",
      20220508: "oq6LSU3Ww5o",
      20220515: "-5sodwqArsQ",
      20220522: "weJ-eJCPpWI",
      20220529: "tSVWIalQV78",
      20220605: "D-OB5yw7jQA",
      20220612: "_yr27O5j8Wc",
      20220619: "KZKgaYRL1kk",
      20220626: "HPIME_34YXc",
      20220703: "5ZluQgRemz4",
      20220731: "IyAG_SDp9qY",
      20220807: "xW96mtbLJYk",
      20220814: "Ljb4SXq9mi4",
      20220821: "FfsFTsvdf9w",
      20220828: "8If0OK-Vjlo",
      20220904: "1Ok_hB4OdOM",
      20220911: "9_lxJItvH8M",
      20220918: "NXq5ZMJ0j_k",
      20220925: "qr_Lcf7gs30",
      20221002: "GIdQxJH-VkY",
      20221016: "uE2uzJXOUhs",
      20221023: "i0-c_XPLHzc",
      20221030: "B46oLAdHcxc",
      20221106: "SOYchnsOnXI",
      20221113: "cJpvIGWMAWM",
      20221120: "X-aiegmYgcA",
      20221127: "GNBUeF--1Yo",
      20221204: "knA2CVnurA8",
      20221211: "lo2TP01zX_4",
      20221218: "IWqjGIhvQ3I",
      20230101: "yVYum11qUv4",
      20230108: "O5vGpTg0Ud8",
      20230115: "vMZTv6_aBjw",
      20230122: "fv2wWIkXOuE",
      20230129: "Xd-vq5dfMDs",
      20230205: "3MmTXLKMeNE",
      20230212: "z7mpgFitcBg",
      20230219: "DOixDKzuggA",
      20230226: "U7qiZcl_YV8",
      20230305: "rif70xYfOso",
      20230312: "X7F_ZsnCi48",
      20230319: "8zPo1DNkdtY",
      20230326: "1_vIekPWEYI",
      20230402: "SKNJgaAJiDU",
      20230409: "Qs2sveVnYns",
      20230416: "uaL5f8bZwUs",
      20230423: "n9FP31MPZeI",
      20230430: "W_TrZxmEmbo",
      20230507: "EHU0E1jSHBY",
      20230514: "u3-YQqQVQXQ",
      20230521: "xBAES9hvIB4",
      20230528: "dY0EwO0OV7I",
      20230604: "WYzdc_4BzOs",
      20230611: "rWPoruIpD_8",
      20230618: "q9k1KH1Ncqs",
      20230625: "TDseRTfMJ84",
      20230702: "E5ZZyNL1JBY",
      20230709: "SOnPtVVV5pE",
      20230716: "pvcGaFiFKgk",
      20230723: "zv--ent_3Cw",
      20230806: "JX6mxZdcxbk",
      20230813: "yiOBVuoV1ac",
      20230820: "B_7T-EimwVQ",
      20230827: "MzkV8fcNOcI",
      20230903: "XnOhegVNjc4",
      20230909: "jwImRSVvRAo",
      20230910: "NeSohSus1gE",
      20230917: "NOgp7b57y9Q",
      20230924: "8fW6TpnvRuA",
      20231001: "ZZaAD7aZnSg",
      20231008: "t--ybY4X9Dg",
      20231015: "1zd0OxyMxwc",
      20231022: "f_jW6DsCS2k",
      20231105: "1QxUIiHHLkI",
      20231112: "gs254-bdMDs",
      20231119: "oeQyVjHtmmQ",
      20231126: "3gsvJzYh5Fs",
      20231202: "PEB793noXkM",
      20231210: "uTjFbG7aGyI",
      20231217: "aOl3AfFDaWA",
      20231231: "t_7xuPouhwE",
      20240107: "XQYbw2x74Ns",
      20240114: "ymguCikPCFc",
      20240121: "vHBCpjjcAtI",
      20240128: "xUNUs3Dnvh8",
      20240204: "Z4q_TjVcRNg",
      20240211: "42fibRya2Vk",
      20240218: "M8_coG16hjc",
      20240225: "fdVHx6_FJCU",
      20240303: "7-S8BDGx9lY",
      20240310: "z-c7t2w3plo",
      20240317: "lq9CrXq7kfM",
      20240324: "v32nZ7GVUE8",
      20240331: "ipltzM0c-MM",
      20240407: "I9k5Zv0MfXE",
      20240414: "U0D3Qwuu4Q8",
      20240421: "OyqYV2v8piQ",
      20240428: "Nsylcullqw4",
      20240505: "a9qwl1JSM4g",
      20240512: "cR36NH_JIso",
      20240526: "0r-cJRO7YKs",
      20240602: "Nobc4PHl428",
      20240609: "udf_UOfAcck",
      20240616: "akMuxVqOCSQ",
      20240623: "dc6Jz5ht9k8",
      20240630: "oAK9lv3GldI",
      20240707: "d4xgpRlXrzE",
      20240714: "Q5wX4arlfs4",
      20240721: "KyxetdjoSu0",
      20240804: "_siUXGgsKQ4",
      20240811: "4CFmGzb3DqI",
      20240818: "9Rde9Zx9olM",
      20240825: "3TjjNRCKqHE",
      20240908: "5Z1cGFsZed8",
      20240915: "FTQJx4b8LSc",
      20240922: "v3-miXQgohk",
      20240929: "wqrzpy4arSs",
      20241002: "xAiMg1aupI8",
      20241013: "xowIMdf1rm8",
      20241020: "I9De4ja-IEs",
      20241027: "zzlaRuwI4co",
      20241103: "aE80L0sNgBY",
      20241110: "jV8TtxRmv0o",
      20241117: "s-D76-vVZjY",
      20241124: "dkAid-gkvWQ",
      20241201: "WslUQc5VjnQ",
      20241208: "CRPGqZvYEp4",
      20241215: "MwECCO6MGP8",
      20241222: "zbrzaEFS-Po",
      20241229: "DZVDs9LLWtQ",
      20250105: "CzvYGxJPeK8",
      20250112: "vRTCLXUP9XA",
      20250119: "CP6teU0-UgQ",
      20250126: "7ByOxHAO8P8",
      20250202: "PuM3e1Gh3gs",
      20250209: "zKk0TamIaGU",
      20250216: "wc3LYyfBOB8",
      20250223: "MGfSiFbYUzk",
      20250302: "wPXHnutZKLw",
      20250309: "qMnTesZ61p0",
      20250316: "UjJUHKBJzv4",
      20250323: "py88Ff6XQ4Q",
      20250330: "L2rJPZKndRA",
      20250413: "HxErqWYZ-d8",
      20250420: "1fRDRWkKokU",
      20250427: "PKDryxZQCxk",
      20250504: "98PkmXs50A0",
      20250511: "TzE5ThDNab0",
      20250518: "TX2-xkQztj8",
      20250608: "l-PaeCT6BIE",
      20250615: "_fbW_XeiU5Y",
      20250622: "snvocV0rqC0",
      20250706: "-F7ihAno6cM",
      20250713: "JBG97ekYnoE",
      20250720: "FL1AAikVFSw",
      20250803: "GfjsYuVAOoE",
      20250810: "nsrvYOErXYY",
      20250817: "NCo8wd9EibQ",
      20250914: "5SEo_9mWecU",
      20250921: "yxeOBGIyjFo",
      20251005: "SRHMJP36dDY",
      20251012: "ilviH6kJZO4",
      20251019: "1d52EsOXHHo",
      20251102: "wRueggO-qXs",
      20251116: "k-x25hmO6Eg",
      20251207: "_lG5ap3vAZY",
      20251214: "xEFt--3_wTQ",
      20260104: "Wl78j_A4ieE",
      20260111: "MpUVOI4AvxY",
      20260118: "WORR19EfK14",
      20260125: "ZCPI5kR_qj8",
      20260201: "HXQuTr5CWXQ",
      20260208: "0YGNHPbg-dQ"
    };

    var date = this.props.clickedDate;
    var link = dateLinkObj[date];

    return (
      <div className="sermon-popup">
        <div className="sermon-video-popup-container">
          <button
            onClick={() => this.props.sermonPopupClose()}
            type="button"
            className="sermon-video-close"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <br />

          <iframe
            width="100%"
            height="300"
            src={`https://www.youtube.com/embed/${link}`}
            frameborder="0"
            allowfullscreen="allowfullscreen"
            mozallowfullscreen="mozallowfullscreen"
            msallowfullscreen="msallowfullscreen"
            oallowfullscreen="oallowfullscreen"
            webkitallowfullscreen="webkitallowfullscreen"
            allow="fullscreen;"
          ></iframe>
        </div>
      </div>
    );
  }
}
